import { render } from "./Business.vue?vue&type=template&id=2f26fe8e&scoped=true"
const script = {}

import "./Business.vue?vue&type=style&index=0&id=2f26fe8e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f26fe8e"]])

export default __exports__